import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import analytics from 'services/middleware/analytics'
import rootReducer from './root-reducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // eslint-disable-line
const configureStore = () =>
  createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk, analytics)),
  )

export default configureStore
